import * as Sentry from "@sentry/react";
import { setAutoFreeze } from "immer";

import "./styles/global.css";
import "./styles/ReactSlickCustom.css";
import "./styles/local.css";

import ReactGA from "react-ga4";

import { env } from "~/env";
import { BrowserNotSupported } from "~/modules/Router/Browser/BrowserNotSupported";
import { Error } from "~/router/routes";
import ContextProvider from "./context";
import AuthGuard from "./modules/Router/Auth/components/AuthGuard";
import Router from "./router";
import StoreProvider from "./store";

// gtag init
if (process.env.NODE_ENV === "production") {
  ReactGA.initialize(env.GA_KEY);
}
setAutoFreeze(false);

function App() {
  const isSupportedBrowser = () => {
    const isChrome = window.navigator.userAgentData?.brands.some(
      ({ brand }) => brand === "Google Chrome",
    );
    return isChrome || env.IS_METAMASK || env.IS_DESKTOP_APP;
  };

  if (!isSupportedBrowser()) {
    return <BrowserNotSupported />;
  }

  return (
    <StoreProvider>
      <ContextProvider>
        <AuthGuard>
          <Sentry.ErrorBoundary fallback={<Error code={"Oops"} />}>
            <Router />
          </Sentry.ErrorBoundary>
        </AuthGuard>
      </ContextProvider>
    </StoreProvider>
  );
}

export default App;
